export const POLL_INTERVAL_MS = 10000;
export const OVERFLOW_RESERVE_PX = 48;
